// Currency is provided by the SDK (ISO 4217). Re-export it as the single source of truth,
// and keep the display symbol/label maps (which the SDK does not provide) alongside it.
import { CurrencyEnum } from "@simbelapp/order-sdk";

export { CurrencyEnum };

// Short symbols appended by formatPrice after stripping Intl's verbose literal.
// Several currencies share "$" — unambiguous since a company has one active currency at a time.
export const CURRENCY_SYMBOLS: Record<CurrencyEnum, string> = {
  EUR: "€",
  USD: "$",
  GBP: "£",
  CHF: "CHF",
  CAD: "$",
  XPF: "F",
  XOF: "F",
  XAF: "F",
  MAD: "DH",
  TND: "DT",
  DZD: "DA",
  JPY: "¥",
  AUD: "$",
  NZD: "$",
  CNY: "¥",
  INR: "₹",
  BRL: "R$",
  MXN: "$",
  ZAR: "R",
  SGD: "$",
  HKD: "$",
  SEK: "kr",
  NOK: "kr",
  DKK: "kr",
  PLN: "zł",
  CZK: "Kč",
  HUF: "Ft",
  RON: "lei",
  AED: "AED",
  SAR: "SAR",
  ILS: "₪",
};

export const CURRENCY_LABELS: Record<CurrencyEnum, string> = {
  EUR: "Euro",
  USD: "Dollar américain",
  GBP: "Livre sterling",
  CHF: "Franc suisse",
  CAD: "Dollar canadien",
  XPF: "Franc pacifique",
  XOF: "Franc CFA (BCEAO)",
  XAF: "Franc CFA (BEAC)",
  MAD: "Dirham marocain",
  TND: "Dinar tunisien",
  DZD: "Dinar algérien",
  JPY: "Yen japonais",
  AUD: "Dollar australien",
  NZD: "Dollar néo-zélandais",
  CNY: "Yuan chinois",
  INR: "Roupie indienne",
  BRL: "Real brésilien",
  MXN: "Peso mexicain",
  ZAR: "Rand sud-africain",
  SGD: "Dollar de Singapour",
  HKD: "Dollar de Hong Kong",
  SEK: "Couronne suédoise",
  NOK: "Couronne norvégienne",
  DKK: "Couronne danoise",
  PLN: "Złoty polonais",
  CZK: "Couronne tchèque",
  HUF: "Forint hongrois",
  RON: "Leu roumain",
  AED: "Dirham des Émirats",
  SAR: "Riyal saoudien",
  ILS: "Shekel israélien",
};
